<div class="header-container">
  <div *ngIf="backDestination !== ''" class="header-back-button">
    <app-back-button link="{{ backDestination }}" useRouter="true" />
  </div>
  <div *ngIf="backDestination == '' && showButton" class="header-back-button">
    <app-link-button
      (click)="onRouterLinkClick()"
      color="primary"
      showIcon="true"
      translate
      >Back</app-link-button
    >
  </div>
  <div *ngIf="title !== ''" class="mat-headline-1 header-title">
    {{ title }}
  </div>
  <div *ngIf="showDate" class="mat-body header-subtitle" id="today">
    {{ today }}
  </div>
  <div
    *ngIf="showClientDetails"
    class="mat-body header-subtitle"
    id="clientDetails"
  >
    {{ age }}<span class="header-subtitle-divider"> | </span>{{ formattedDob }}
  </div>
</div>
